import L from 'leaflet';
import { memo } from 'react';
import { Marker, Popup } from 'react-leaflet';

import { IVehicle } from '../../../schema/Vehicle.ts';
import { VehicleBadge } from '../../ui/Badge.tsx';

const vehicle_in_operation = new L.Icon({
  iconUrl: '/theme/media/leaflet_padam_icons/bus-in-operation.svg',
  iconSize: [60, 60],
  popupAnchor: [0, -50],
  iconAnchor: [35, 65],
});

const vehicle_selected_icon = new L.Icon({
  iconUrl: '/theme/media/leaflet_padam_icons/bus-selected.svg',
  iconSize: [70, 70],
  popupAnchor: [0, -55],
  iconAnchor: [40, 75],
});

const vehicle_inactive_icon = new L.Icon({
  iconUrl: '/theme/media/leaflet_padam_icons/bus-inactive.svg',
  iconSize: [50, 50],
  popupAnchor: [0, -50],
  iconAnchor: [25, 50],
});

type VehicleVariant = 'selected' | 'in-operation' | 'inactive';

const vehicleIcons: Record<VehicleVariant, L.Icon> = {
  selected: vehicle_selected_icon,
  'in-operation': vehicle_in_operation,
  inactive: vehicle_inactive_icon,
};

type VehicleMarkerProps = {
  vehicle: IVehicle & { latitude: number; longitude: number };
  variant: VehicleVariant;
};

export const VehicleMarker = memo(function VehicleMarker({
  vehicle,
  variant,
}: Readonly<VehicleMarkerProps>) {
  return (
    <Marker icon={vehicleIcons[variant]} position={[vehicle.latitude, vehicle.longitude]}>
      <Popup>
        <div className="d-flex align-items-center gap-2">
          <VehicleBadge vehicle={vehicle} />
          <span className={'card-text'}>{vehicle.display_identifier}</span>
        </div>
        <div className={'mt-2'}>
          <span className={'text-basic'}>
            ({vehicle.latitude.toFixed(4)}; {vehicle.longitude.toFixed(4)})
          </span>
        </div>
        <div className={'text-basic mt-2'}>
          <span className={'text-basic'}>{vehicle.next_node}</span>
        </div>
      </Popup>
    </Marker>
  );
});
